module.exports = __webpack_public_path__ + "img/specials-multislider-infiniti.36526825.png";